import { useEffect, useRef, useState } from "react";
import { get } from "lodash";
import { v4 as uuid } from "uuid";
import { useSelector, useDispatch } from "react-redux";
import { getBetSelections } from "@tvg/desktop-bet/src/store/selectors";
import { resetBetSelection } from "@tvg/desktop-bet/src/store/actions";
import { RaceProgram, RaceStatusEnum } from "@tvg/ts-types/Race";
import { getProgramPageMessages } from "../store/selectors";
import { isRaceoff as isRaceoffUtil } from "../utils/raceUtils";
import { addToast, removeToast } from "../store/actions";

const useRaceoff = (currentRace: RaceProgram) => {
  const [toastId, setToastId] = useState("");

  const dispatch = useDispatch();
  const isRaceoff = isRaceoffUtil(currentRace);
  const raceId = currentRace.tvgRaceId;
  const prevRaceId = useRef<number | undefined>(raceId);
  const programPageMessages = useSelector(getProgramPageMessages);
  const betSelections = useSelector(getBetSelections);
  const hasBetsBetslip = betSelections && betSelections.flat().length > 0;
  const isRaceResulted =
    get(currentRace, "status.code", "") === RaceStatusEnum.RACE_OFFICIAL;

  useEffect(() => {
    setToastId(uuid());

    const isSameRace = raceId && prevRaceId && raceId === prevRaceId.current;
    if (
      isSameRace &&
      isRaceoff &&
      !isRaceResulted &&
      document.visibilityState === "visible"
    ) {
      const isRaceoffWithBetslip = isRaceoff && hasBetsBetslip;
      const toastMessage = isRaceoffWithBetslip
        ? get(programPageMessages, "raceoff.toastMessageSelections", "")
        : "";

      dispatch(
        addToast({
          id: toastId,
          variant: "informational",
          title: get(programPageMessages, "raceoff.toastMessage", ""),
          message: toastMessage,
          hasDismissButton: false,
          actionLink: "",
          qaLabel: "race-off-toast",
          onHide: () => dispatch(removeToast(toastId)),
          onDismissPress: () => dispatch(removeToast(toastId))
        })
      );

      if (isRaceoffWithBetslip) {
        dispatch(resetBetSelection());
      }
    }
    if (isRaceResulted) {
      dispatch(removeToast(toastId));
    }
    prevRaceId.current = raceId;
  }, [isRaceoff, raceId, isRaceResulted]);
};

export default useRaceoff;
